export enum GlobalSettingsKeys {
  GOOGLE_CALENDAR_ENABLED = 'GOOGLE_CALENDAR_ENABLED',
  GOOGLE_ENABLED = 'GOOGLE_ENABLED',
  GOOGLE_CONTACTS_ENABLED = 'GOOGLE_CONTACTS_ENABLED',
  EWS_CALENDAR_ENABLED = 'EWS_CALENDAR_ENABLED',
  EXCHANGE_ONLINE_CALENDAR_ENABLED = 'EXCHANGE_ONLINE_CALENDAR_ENABLED',
  CALDAV_ENABLED = 'CALDAV_ENABLED',
}
